import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import ModernDashboard from './components/ModernDashboard';
import StorageDashboard from './components/StorageDashboard';
import NetworkingDashboard from './components/NetworkingDashboard';
import SSHKeysDashboard from './components/SSHKeysDashboard';
import SnapshotsDashboard from './components/SnapshotsDashboard';
import MarketplaceDashboard from './components/MarketplaceDashboard';
import BillingDashboard from './components/BillingDashboard';
import AlertsDashboard from './components/AlertsDashboard';
import OperatorDashboard from './components/OperatorDashboard';
import AdminDashboard from './components/AdminDashboard';
import ClusterDashboard from './components/ClusterDashboard';

function App() {
  return (
    <Router>
      <Routes>
        {/* Customer Routes */}
        <Route path="/" element={<Login userType="customer" />} />
        <Route path="/login" element={<Login userType="customer" />} />
        <Route path="/register" element={<Register />} />
        <Route 
          path="/dashboard" 
          element={
            localStorage.getItem('access_token') 
              ? <ModernDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/storage" 
          element={
            localStorage.getItem('access_token') 
              ? <StorageDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/networking" 
          element={
            localStorage.getItem('access_token') 
              ? <NetworkingDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/ssh-keys" 
          element={
            localStorage.getItem('access_token') 
              ? <SSHKeysDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/snapshots" 
          element={
            localStorage.getItem('access_token') 
              ? <SnapshotsDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/clusters" 
          element={
            localStorage.getItem('access_token') 
              ? <ClusterDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/marketplace" 
          element={
            localStorage.getItem('access_token') 
              ? <MarketplaceDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/billing" 
          element={
            localStorage.getItem('access_token') 
              ? <BillingDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />
        <Route 
          path="/alerts" 
          element={
            localStorage.getItem('access_token') 
              ? <AlertsDashboard /> 
              : <Navigate to="/login" replace />
          } 
        />

        {/* Operator Routes */}
        <Route path="/operator/login" element={<Login userType="operator" />} />
        <Route 
          path="/operator/dashboard" 
          element={
            localStorage.getItem('operator_token') 
              ? <OperatorDashboard /> 
              : <Navigate to="/operator/login" replace />
          } 
        />

        {/* Admin Routes */}
        <Route 
          path="/admin/dashboard" 
          element={
            localStorage.getItem('operator_token') 
              ? <AdminDashboard /> 
              : <Navigate to="/operator/login" replace />
          } 
        />

        {/* Catch all - redirect to customer login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
